import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import type { Tagged } from "@-/com.npmjs.type-fest";
import { getGraphemeMeaningImageUrlPath } from "@-/dev.improve.haniverse.assets.graphemes.meaning.images/public";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";

export type MorphemeMnemonicsMeaningViewImageSectionGate = Tagged<
  { meaningImageUrlPath: string },
  "MorphemeMnemonicsMeaningViewImageSectionGate"
>;

/**
 * Whether the meaning view shows its illustration. `null` is the designed hidden state: the
 * grapheme has no meaning image, or grapheme images (experimental, off by default) are disabled.
 */
export function useMorphemeMnemonicsMeaningViewImageSectionGate(): MorphemeMnemonicsMeaningViewImageSectionGate | null {
  const [front] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.grapheme,
  );
  const [isGraphemeImagesEnabled] = useDeviceSetting("isGraphemeImagesEnabled");
  const meaningImageUrlPath = getGraphemeMeaningImageUrlPath(front);
  return !isGraphemeImagesEnabled || meaningImageUrlPath === null
    ? null
    : createGate<MorphemeMnemonicsMeaningViewImageSectionGate>({ meaningImageUrlPath });
}
